/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './team-ownership-modal.component.html';
import {SiteResource} from '../../../components/api/resources/resource/site.resource';
import {AdnModalLoadingService} from '../../common/util/adn-modal-loading.service';

@Component({
  standalone: false,
  selector: 'adn-team-ownership-modal',
  template
})
export class TeamOwnershipModalComponent implements OnInit {
  obj: any;
  removeMode = false;
  ownerSites: any[] = [];
  unownedSites: any[] = [];

  readonly onSaved = new Subject<void>();

  objects: any[] = [];
  selectedObjectIds: string[] = [];
  validationErrors: any[] = [];
  disabled = false;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(SiteResource) private readonly Site: any,
    @Inject(AdnModalLoadingService) private readonly adnModalLoading: any
  ) {
  }

  ngOnInit(): void {
    this.objects = _.cloneDeep(this.removeMode ? this.ownerSites : this.unownedSites);
    this.selectedObjectIds = [];
  }

  selectObjects(): void {
    this.selectedObjectIds = _.map(this.objects, 'id');
  }

  deselectObjects(): void {
    this.selectedObjectIds = [];
  }

  isSelected(objectId: string): boolean {
    return this.selectedObjectIds.indexOf(objectId) > -1;
  }

  toggleObject(objectId: string, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const selected = [...this.selectedObjectIds];
    const index = selected.indexOf(objectId);
    if (checked && index < 0) {
      selected.push(objectId);
    } else if (!checked && index > -1) {
      selected.splice(index, 1);
    }
    this.selectedObjectIds = selected;
  }

  trackByObjectId(_index: number, object: any): string {
    return object.id;
  }

  saveAndClose(): void {
    this.disabled = true;
    this.adnModalLoading.applyModalLoading();

    const objectsForUpdating = _.map(this.selectedObjectIds, (objectId: string) => ({
      id: objectId,
      ownerTeam: this.removeMode ? null : _.pick(this.obj, ['id'])
    }));

    this.Site.bulkSave(objectsForUpdating).$promise.then(() => {
      this.disabled = false;
      this.onSaved.next();
      this.adnModalLoading.removeModalLoading();
      this.bsModalRef.hide();
    }, (errors: any) => {
      this.disabled = false;
      this.validationErrors = _.get(errors, ['data', 'errors'], []);
      this.adnModalLoading.removeModalLoading();
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
